/*
application.service.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
/**
 * @ngdoc service
 * @name AppConfigProvider
 * @description The AppConfigProvider allows application modules to register themselves with the application
 * shell in their config() functions.  The AppConfigProvider will then take care of registering their states
 * with the ui-router $stateProvider.
 * @requires $stateProvider
 */
define('modules/shell/services/application.service',[
    'lodash',
    '../module',
    'lodash'
], function (_, module) {
    'use strict';

    module.provider('uaf.appshell.AppConfig', ['$stateProvider', function ($stateProvider) {
        var modules = {};

        var validateModuleName = function (name) {
            if (typeof name !== 'string' || !name) {
                throw new TypeError('Invalid name module configuration (' + name + '). name is not string or is empty string');
            }
        };

        var validateModuleHREF = function (href, name) {
            if (typeof href !== 'string' || !href) {
                throw new TypeError('Invalid href module configuration (' + name + '). href is not string or is empty string');
            }
        };

        var validateController = function (controller, name) {
            if (controller && typeof controller !== 'string') {
                throw new TypeError('Invalid controller module configuration (' + name + '). controller is not string or is empty string');
            }
        };

        var validateTemplateUrl = function (templateUrl, name) {
            if (typeof templateUrl !== 'string' || !templateUrl) {
                throw new TypeError('Invalid templateUrl module configuration (' + name + '). templateUrl is not string or is empty string');
            }
        };

        var validateParameters = function (appModule) {
            if ('parameters' in appModule && typeof appModule.parameters !== 'object') {
                throw new TypeError('Invalid parameters module configuration (' + appModule.title + ' - ' + appModule.name + '). parameters is not an object');
            }
        };

        var validateModule = function (appModule) {
            validateModuleName(appModule.name);
            validateModuleHREF(appModule.href, appModule.name);
            validateController(appModule.controller, appModule.name);
            validateTemplateUrl(appModule.templateUrl, appModule.name);
            validateParameters(appModule);
        };

        this.addAppDescriptor = function (appModule) {
            validateModule(appModule);

            if (appModule.secure !== 'false') {
                appModule.parent = 'secure';
            }


            var resolveDependencies = function ($q, $rootScope, dependencies) {
                var defer = $q.defer();

                require(dependencies, function () {
                    defer.resolve();
                    $rootScope.$apply();
                });

                return defer.promise;
            };

            if (appModule.dependencyFiles) {
                appModule.resolve = _.extend(appModule.resolve || {}, {
                    load: ['$q', '$rootScope', function ($q, $rootScope) {
                        return resolveDependencies($q, $rootScope, appModule.dependencyFiles);
                    }]
                });
            }

            var urlParameters = '';
            if (appModule.parameters && typeof appModule.parameters === 'object') {
                for (var param in appModule.parameters) {
                    if (appModule.parameters.hasOwnProperty(param)) {
                        urlParameters += '/{' + appModule.parameters[param] + '}';
                    }
                }
            }
            appModule.url = appModule.href + urlParameters;

            $stateProvider.state(appModule.name, appModule);

            modules[appModule.name] = appModule;
        };



        this.$get = ['$state', function ($state) {
            return {
                getActiveModule: function () {
                    var name;
                    for (name in modules) {
                        if (modules.hasOwnProperty(name) && $state.current.name.indexOf(name + '.') === 0 || $state.current.name === name) {
                            return modules[name];
                        }
                    }
                },
                getModuleByState: function (state) {
                    var name;
                    for (name in modules) {
                        if (modules.hasOwnProperty(name) && state.indexOf(name + '.') === 0 || state === name) {
                            return modules[name];
                        }
                    }
                }
            };
        }];
    }]);
});
